import v37Schema from '../client/schemaVersions/v37.js';
import v38Schema from '../client/schemaVersions/v38.js';
import { createMigration } from '@verdant-web/store';
export default createMigration(v37Schema, v38Schema, async ({ migrate }) => {
    await migrate('foods', (old) => {
        return Object.assign(Object.assign({}, old), { inInventory: !!old.lastPurchasedAt });
    });
});
//# sourceMappingURL=v38.js.map